/* @flow */
/**
 * Provides helpers for building GAC change history field lists from report headers.
 */
import gacChangeHistoryReportHeader from '../../constants/gacChangeHistoryReportHeader';

/**
 * Adds default, secondary, additional, and request-only fields to a GAC change history field list.
 */
export default function getFieldsList(GACChangeHistorySecondaryFields: Object) {
  gacChangeHistoryReportHeader
    // Only default columns seed the secondary field request list.
    .filter((header) => header.default)
    .forEach((header) => {
      GACChangeHistorySecondaryFields.push(header.primary);
      if (header.secondary) {
        GACChangeHistorySecondaryFields.push(header.secondary);
      }
      // Some visible columns require hidden backing fields in the API request.
      if (header.additionalFields) {
        GACChangeHistorySecondaryFields.push(...header.additionalFields);
      }
      if (header.includeInRequest) {
        GACChangeHistorySecondaryFields.push(header.primary);
      }
    });
}
